<rpe-page-template title="Gestión de trámites" route="main/landing">
  <ng-container slot="content">
  <div class="layout">
  <div class="content">
    <mat-card>
      <mat-card-content>
        <rpe-vista-tramite-table [tramiteTableInput]="this.tramiteTableData"></rpe-vista-tramite-table>
      </mat-card-content>
    </mat-card>
  </div>
</div>
</ng-container>
</rpe-page-template>